import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import "./Jumpstart.css";

const PATENT_URL = "https://patents.google.com/patent/US10086275B2/en?oq=10086275";

const PROJECTS = [
  { id: "qBJrdKO52n4", title: "Paralect", caption: "IGF 2014 finalist", link: "https://igf.com/archive-2014/" },
  {
    id: "zRJmgAiXWuM",
    title: "Crowd Game",
    caption: "My patented software process (US10086275B2)",
    patent: PATENT_URL,
  },
  { id: "lSjn0B1xuY4", title: "Project" },
  {
    id: "6HJpvZCQDQE",
    title: "Crowd Game at Sparks",
    caption: "My patented software process (US10086275B2)",
    patent: PATENT_URL,
  },
  { id: "d1HFXDExuaU", title: "VolleyBomb" },
  { id: "FBRF1Kx3pfg", title: "DreamWorks VR" },
];

export default function Jumpstart() {
  return (
    <>
      <Nav />
      <main className="jumpstart">
        <div className="jumpstart__inner">
          <header className="jumpstart__header">
            <h1 className="jumpstart__title">Other games</h1>
            <p className="jumpstart__subtitle">
              Some of my games and past work.
            </p>
          </header>
          <div className="jumpstart__grid">
            {PROJECTS.map((project) => (
              <article key={project.id} className="jumpstart__card">
                <div className="jumpstart__video">
                  <iframe
                    src={`https://www.youtube.com/embed/${project.id}`}
                    title={project.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
                {project.caption && (
                  <p className="jumpstart__caption">
                    {project.patent || project.link ? (
                      <a
                        href={project.patent || project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {project.caption}
                      </a>
                    ) : (
                      project.caption
                    )}
                  </p>
                )}
              </article>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
